module.exports = "../dist/img/img_1-28.aa16.jpg";